import React, { useState } from "react";
import { UserApi } from "../api-services/user.api";
import { MessageApi } from "../api-services/message.api";
import { OrderApi } from "../api-services/order.api";
import data from "../data/data";


export function OrderingForm()
{
      const order = OrderApi(); 

      const [inputs, setInputs] = useState({
        name: "", phone: "", product: "", unitPrice: 0, quantity: 1, totalPrice: 0,
      });
      const [status, setStatus] = useState(0);
      const [isLoading, setIsLoading] = useState(false);


      const handleInputs = (event) => {
      const { name, value } = event.target;

      // If product is selected, we set unitPrice automatically
      if (name === "product") {
        const selectedProduct = data?.equipment.find((p) => p.name === value);
        if (selectedProduct) {
          setInputs((prev) => ({
            ...prev,
            product: value,
            unitPrice: selectedProduct.price,
            totalPrice: selectedProduct.price * prev.quantity,
          }));
        }
      }
      // If quantity is updated → update totalPrice
      else if (name === "quantity") {
        setInputs((prev) => ({
          ...prev,
          quantity: Number(value),
          totalPrice: prev.unitPrice * Number(value),
        }));
      }
      // Other inputs 
      else {
        setInputs((prev) => ({ ...prev, [name]: value }));
      }
    };
     
    const handleForm = async ( event ) => {
        event.preventDefault();
        setIsLoading(true);
        setStatus(0);
        try {
            const res = await order.insert(inputs);
            setIsLoading(false);
            // console.log(res.data);
            (res.data.success) ? setStatus(1) : setStatus(-1);  
        } catch (err) { 
            setIsLoading(false);
            setStatus(-1); 
        }
    } 
   

    return (
                     
      <form className="" onSubmit={ handleForm }>
          <div className="row">                                     
              <div className="col-md-12 mb-2"> 
                <div className="d-flex mb-3" > 
                  <span className="color-blue h4"> Commande </span>

                </div>
                {
                  isLoading && (
                    <div className="d-flex justify-content-center align-items-center mb-3"> 
                      <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }
                {
                  status === 1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-success">
                        Commande envoyé avec succes.
                      </div>
                    </div>
                  )
                }
                {
                  status === -1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-danger">
                        Une erreur est survenue durant l'envoie. Veuillez réessayer
                      </div>
                    </div>
                  )
                }
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Votre nom ( <span className="text-danger"> * </span> ) </span>
                  <input type="text" name="name" className="border input p-2 text-muted" onChange={ handleInputs } required />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                <span className="text-muted small"> Votre numéro de téléphone joignable ( <span className="text-danger"> * </span> ) </span>
                  <input type="phone" name="phone" className="border input p-2 text-muted" onChange={ handleInputs } required />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2">
                <div className="d-flex flex-column mb-2">
                  <span className="text-muted small"> Le produit ( <span className="text-danger"> * </span> ) </span>
                  <select name="product" className="border input p-2 text-muted" onChange={handleInputs} required>
                    <option value="">-- Choisissez un produit --</option>
                    { data?.equipment.map((p, i) => (
                      <option key={i} value={p.name}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Prix unitaire </span>
                  <input type="number" name="unitPrice" value={inputs.unitPrice} className="border input p-2 text-muted" />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Nombre d'Edge à acheter ( <span className="text-danger"> * </span> ) </span>
                  <input type="number" name="quantity" value={inputs.quantity} className="border input p-2 text-muted" onChange={ handleInputs } />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-4"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Prix total </span>
                  <input type="number" name="totalPrice" value={inputs.totalPrice} className="border input p-2 text-muted" />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                  <button className="btn btn-outline-success" type="submit"> Commander maintenant </button>
              </div>     
          </div> 
      </form>
                              
    )
}



export function ContactForm()
{
    const message = MessageApi();

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
   
    const handleInputs = ( event ) => {
        const { name , value } =  event.target;
        setInputs( { ...inputs, [name] : value   } );
    }
     
    const handleForm = async ( event ) => {
        event.preventDefault();
        setIsLoading(true);
       
        try {
            const res = await message.insert(inputs);
            setIsLoading(false);
            (res.data.success) ? setStatus(1) : setStatus(-1); 
        } catch (err) { 
            setIsLoading(false);
            setStatus(-1); 
        }
    } 
   

    return (
                     
      <form className="" onSubmit={ handleForm }>
          <div className="row">                                     
              <div className="col-md-12 mb-2"> 
                <div className="d-flex mb-3" > 
                  <span className="color-blue h4"> Nous contacter </span>
                </div>
                {
                  isLoading && (
                    <div className="d-flex justify-content-center align-items-center mb-3"> 
                      <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }
                {
                  status === 1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-success">
                        Message envoyé avec succes.
                      </div>
                    </div>
                  )
                }
                {
                  status === -1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-danger">
                        Une erreur est survenue durant l'envoie. Veuillez réessayer
                      </div>
                    </div>
                  )
                }
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Votre nom ( <span className="text-danger"> * </span> ) </span>
                  <input type="text" name="name" className="border input p-2 text-muted" onChange={ handleInputs } required />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                <span className="text-muted small"> Votre numéro de téléphone joignable ( <span className="text-danger"> * </span> ) </span>
                  <input type="number" name="phone" className="border input p-2 text-muted" onChange={ handleInputs } required />
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Votre email </span>
                  <input type="email" name="email" className="border input p-2 text-muted" onChange={ handleInputs }/>
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-3"> 
                <div className="d-flex flex-column mb-2" >
                  <span className="text-muted small"> Votre message ( <span className="text-danger"> * </span> ) </span>
                  <textarea className="border input p-2 text-muted" rows={6} name="message" onChange={ handleInputs } required >  </textarea>
                </div>
              </div>
              {/* -------------------------------- */}
              <div className="col-md-12 mb-2"> 
                  <button className="btn btn-outline-success" type="submit"> Envoyer maintenant </button>
              </div>     
          </div> 
      </form>
                               
    )
}



export function PasswordForm()
{

    const user = UserApi();
    const [ inputs, setInputs ] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleInputs = ( event ) => {
        const { name , value } =  event.target;
        setInputs( { ...inputs, [name] : value   } );
    }

    const handleForm = async ( event ) => {
        event.preventDefault();
        // console.log(inputs);
        setIsLoading(true);
        if(inputs.password ===inputs.cpassword )
        {    
            try {
                const res = await user.updatePassword(inputs);
                (res.data.success) ? setStatus(1) : setStatus(-1);
                setIsLoading(false);
            } catch (err) { 
                setStatus(-1); 
                setIsLoading(false);
            }   
        }
        else{ setStatus(-2) }
    } 

    return (

      <div className="d-flex flex-column">
          <div className="my-4 text-muted text-center">────────  Suite  ────────</div>

          <form onSubmit={ handleForm } className="d-flex flex-column">
            <span className="text-muted text-start mb-4 fs-6"> Saisir le code reçu par message ainsi que votre nouveau mot de passe.  </span>
            {
              isLoading && (
                <div className="d-flex justify-content-center align-items-center mb-3"> 
                   <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="col-md-12 mb-2">
                  <div className="alert alert-success">
                    Votre mot de passe est modifié avec succès
                  </div>
                </div>
              )
            }
            {
              status === -1 && (
                <div className="col-md-12 mb-2">
                  <div className="alert alert-danger">
                    Une erreur est survenue durant le traitement. Vérifiez réessayer.
                  </div>
                </div>
              )
            }
            {
              status === -2 && (
                <div className="col-md-12 mb-2">
                  <div className="alert alert-danger">
                    Veuillez vérifier vos mot de passe puis réessayez.
                  </div>
                </div>
              )
            }
            {/* -------------------------------- */}
            <div className="col-md-12 mb-2"> 
              <div className="d-flex gap-2 mb-2" >
                <input type="number" name="code" placeholder="Code" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
              </div>
            </div>
            {/* -------------------------------- */}
            <div className="col-md-12 mb-2"> 
              <div className="d-flex gap-2 mb-2" >
                <input type="password" name="password" placeholder="Nouveau mot de passe" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
              </div>
            </div>
            {/* -------------------------------- */}
            <div className="col-md-12 mb-2"> 
              <div className="d-flex gap-2 mb-2" >
                <input type="password" name="cpassword" placeholder="Confirmer le mot de passe" className="w-100 border input py-3 px-3 text-muted rounded-2" onChange={ handleInputs } required />
                <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
              </div>
            </div>
            {/* -------------------------------- */}   
            <button type="submit" className="btn btn-lg btn-outline-success px-4 mt-2"> Enregistrer </button> 
                   
          </form>        

          {
              status === 1 && (
                  <div className="d-flex justify-content-center p-4 mt-4 bg-white rounded-3 border">
                    <a className="btn btn-sm btn-outline-dark d-flex align-items-center px-4" href="/">
                      Retour à la page d'accueil <i className="bi bi-arrow-right ms-2"></i>
                    </a>
                  </div>
              )
          }

      </div>
            
    )
}